import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import failImg from 'static/images/icons/fail.png';
import { Source } from 'types/funding';
import './style.scss';

interface NoBindAchProps {
    onRetry: () => void;
    source: Source;
}

const NoBindAch: React.FC<NoBindAchProps> = ({ onRetry, source }) => {
    return (
        <div className="no-bind-ach-root">
            <img className="error-img" src={failImg} alt="" />
            <p className="desc">
                {__(
                    `Uh oh! We've failed to check your account balance. Please use our Bank Account Linkage function to continue initiating your deposit.`
                )}
            </p>
            <CardButtonWrap className="btn-box">
                <Button size="large" onClick={onRetry}>
                    {__('重试')}
                </Button>
                <Link
                    className="w-100"
                    to="/profile/bankcards/auth/select-way"
                    state={{
                        source: source
                    }}
                    replace>
                    <Button type="primary" size="large">
                        {__('Return to Link Again')}
                    </Button>
                </Link>
            </CardButtonWrap>
        </div>
    );
};

export default NoBindAch;
